import location from "assets/location.svg"
import L from "leaflet"

export const LocationIcon = new L.Icon({
  iconUrl: location,
  iconRetinaUrl: location,
  iconAnchor: undefined,
  popupAnchor: undefined,
  shadowUrl: undefined,
  shadowSize: undefined,
  shadowAnchor: undefined,
  iconSize: new L.Point(14, 14),
  className: "leaflet-div-icon",
})

export const REACT_MAP_SOURCE =
  "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
